

import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'

export default function BlockUser({ userMobile }) {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV

  const baseUrl =
    nodeMode === 'development' ? beckendLocalApiUrl : beckendLiveApiUrl

  // pagination
  const [limit, setLimit] = useState(10)
  const [pageNumber, setPageNumber] = useState(1)
  const [numberOfPages, setNumberOfPages] = useState(0)

  // search (kept for compatibility)
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState(0)
  const [findByStatus, setFindByStatus] = useState(0)
  const [findByuserStatus, setFindByuserStatus] = useState('')

  // data
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)

  const setpageLimit = (event) => {
    setLimit(event.target.value)
  }

  const handlePageClick = (data) => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const searchHandler = (event) => {
    setSearchList(event.target.value)
  }

  const searchByStatus = (event) => {
    let key = event.target.value
    setFindByStatus(key)
    setFindByuserStatus(key)
  }

  const getUser = async () => {
    try {
      setLoading(true)
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`,
      }

      const res = await axios.get(
        baseUrl +
          `User/block?page=${pageNumber}&_limit=${limit}`,
        { headers },
      )

      setUsers(res.data.users || [])
      setNumberOfPages(res.data.totalPages || 0)
      setLoading(false)
    } catch (e) {
      console.error(e)
      alert('Failed to load block users')
      setLoading(false)
    }
  }

  const blockPlayer = (player) => {
    const confirmBox = window.confirm(
      `Are you sure you want to unblock ${player.Name}?`
    )

    if (confirmBox === true) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`,
      }

      axios
        .post(
          baseUrl + `block/user/${player._id}`,
          { user_type: 'User' },
          { headers },
        )
        .then(() => {
          getUser()
        })
    }
  }

  useEffect(() => {
    getUser()
  }, [pageNumber, limit])

  if (loading) {
    return <div className="text-center mt-5">Loading Block Users...</div>
  }

  return (
    <div className="other_page_cards_main">
      <h4 className="other_page_cards_heading my-3">Blocked Users</h4>

      <div className="row">
        <div className="col-12 grid-margin">
          <div className="table-responsive mt-3">
            <table className="table other_page_table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Balance</th>
                  <th>Hold</th>
                  <th>Referral</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {users.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center text-danger">
                      No Block Users Found
                    </td>
                  </tr>
                ) : (
                  users.map((user, key) => (
                    <tr key={user._id}>
                      <td>{key + 1}</td>
                      <td>{user._id}</td>
                      <td className="text-primary">{user.Name}</td>
                      <td className="text-success">
                        {userMobile
                          ? user.Phone
                          : `${user.Phone.toString().slice(0, 2)}****${user.Phone
                              .toString()
                              .slice(-2)}`}
                      </td>
                      <td>₹{user.Wallet_balance}</td>
                      <td>{user.hold_balance}</td>
                      <td>{user.referral || '-'}</td>
                      <td>
                        <span className="badge badge-danger">
                          {user.user_type}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-success btn-sm mx-1"
                          onClick={() => blockPlayer(user)}
                        >
                          Unblock
                        </button>

                        <Link
                          className="btn btn-info btn-sm mx-1"
                          to={`/user/adduser/${user._id}`}
                        >
                          Edit
                        </Link>

                        <Link
                          className="btn btn-primary btn-sm mx-1"
                          to={`/user/view_user/${user._id}`}
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={numberOfPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={'pagination justify-content-center'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
